<template>
<div>
  <v-alert type="success" v-if="sent">
    <strong>{{ $t('Ihre Anfrage wurde abgeschickt, bitte überprüfen Sie Ihr E-Mail-Postfach, um diese zu bestätigen.') }}</strong>
  </v-alert>

  <v-form @submit="submit" v-if="!sent">
    <v-alert type="error" v-if="error">
      <strong>{{ $t('Es ist ein Fehler aufgetreten.') }}</strong>
    </v-alert>

    <v-alert type="error" v-if="userError">
      <strong>{{ $t('Bitte prüfen Sie Ihre Eingaben.') }}</strong>
    </v-alert>

    <contact-form ref="contactForm" :enable-message="true"></contact-form>

    <div class="text-center mt-8">
      <v-btn @click="submit" color="primary" large :loading="loading">Anfrage senden</v-btn>
    </div>
  </v-form>
</div>
</template>

<script>
import ContactForm from "../ContactForm";

export default {
  name: "ContactFormWizard",

  components: {
    ContactForm
  },

  data() {
    return {
      sent: false,
      error: false,
      userError: false,
      message: null
    }
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    }
  },

  methods: {

    submit(e) {
      e.preventDefault();

      const contactForm = this.$refs.contactForm;

      if (!contactForm.validate()) {
        this.userError = true;
        return;
      }

      const payload = {
        contact: contactForm.contact,
        message: "" + contactForm.message
      }

      this.$store.dispatch("ajax", {
        url: "/v1/wizard/contact",
        method: "post",
        data: payload
      }).then(res => {
        this.sent = true;
      }).catch(err => {
        this.error = true;
      });
    }
  }
};
</script>
